import React from "react";
import {HistoryOutlined} from "@mui/icons-material";
import Applet from "../../Applet";
import ObjectAuditHistoryTable from "../../../../components/Foundation/ObjectAuditHistoryTable";

// The History tab's grid. Read-only: rows come from the backend's audit hooks, so there is no
// add/edit/delete menu.
class ObjectAuditHistoryTableApplet extends Applet {

    render() {
        return <ObjectAuditHistoryTable applet={this}
                                        pageSize={this.props.PageSize ?? this.state.PageSize}
                                        placement={this.state.Placement}
                                        columns={this.state.Columns}
                                        title="History"
                                        icon={<HistoryOutlined/>}
                                        enterpriseComponent={this.getEnterpriseComponent()}
                                        sort={this.state.Sort}
                                        menu={this.state.Menu}
                                        rowHeight={this.state.RowHeight}
                                        enableSearch={false}
                                        enableSort={true}
        />;
    }

    state = {
        Name: "ObjectAuditHistoryTableApplet",
        Menu: {options: [{displayValue: "Refresh", value: "Refresh"}]},
        RowHeight: 48,
        PageSize: {"default": 20, "xs": 3, "sm": 3, "md": 20, "lg": 20, "lx": 20},
        Placement: {
            "xl": [
                {id: "CreatedDatetime"},
                {id: "ModificationType"},
                {id: "CreatedByName"},
                {id: "RevisionName"},
                {id: "Change"},
            ],
        },
        Columns: [
            {id: "CreatedDatetime", width: 190, cellRenderer: "Local Datetime Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "When", hideable: false},
            {id: "ModificationType", width: 130, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Action", hideable: false},
            // The actor AS THEY WERE at the time -- a snapshot on the audit row, not a live lookup.
            {id: "CreatedByName", width: 200, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "By", hideable: false},
            {id: "RevisionName", width: 260, cellRenderer: "Standard Single Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Revision"},
            {id: "Change", width: 420, cellRenderer: "Change Summary Cell", header: "enabled", headerRenderer: "Standard Single Header", headerTitle: "Changes"},
        ],
        // Newest first: a history tab that opened on the oldest entry would be useless.
        Sort: [
            {
                "Identifier": "When",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "DESC",
                    "SortAttribute": "CreatedDatetime",
                    "DisplayName": "When",
                }],
            },
        ],
    };
}

export default ObjectAuditHistoryTableApplet;
